import { render } from "./ScreenOutQuestion.vue?vue&type=template&id=641ce502&scoped=true"
import script from "./ScreenOutQuestion.vue?vue&type=script&lang=js"
export * from "./ScreenOutQuestion.vue?vue&type=script&lang=js"

import "./ScreenOutQuestion.vue?vue&type=style&index=0&id=641ce502&scoped=true&lang=scss"

import exportComponent from "/builds/Partout/motus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641ce502"]])

export default __exports__